<div class="modal-header">
  <h4 class="modal-title">{{(ip ? 'BUY_STATIC_IP' : 'BUY_ITEM') | translate}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="done.emit()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="app-content content container-fluid left">
  <div class="content-wrapper">

    <div class="content-body">
      <ngb-tabset [justify]="'center'">
        <ng-container *ngFor="let group_item of items">
          <ngb-tab id="{{group_item.group_name}}">
            <ng-template ngbTabTitle>
              {{ group_item.group_name | translate }}
            </ng-template>
            <ng-template ngbTabContent>

              <div class="row">
                <ng-container *ngFor="let item of group_item.items">
                  <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12" *ngIf="!item.assigns || item.assigns.length">

                    <div class="card box-shadow-2 text-center m-2">
                      <div class="card-body">
                        <div class="card-block">
                          <h4 class="card-title">{{item['item_name_' + lang]}}</h4>
                        </div>

                        <img *ngIf="item.image_url" class="img-fluid fit" [src]="item.image_url"
                          alt="{{item.item_name}}" style="max-height: 220px;">
                        <div class="card-block">
                          <label *ngIf="!ip && !item.assigns">
                            <input class="form-control d-inline-block  width-65-per" type="number"
                              [(ngModel)]="item.quantity" style="max-width: 100px;"> {{item.unit | translate}}

                          </label>
                          <dx-select-box class="mb-1" *ngIf="item.assigns?.length" [dataSource]="item.assigns"
                            valueExpr="id" displayExpr="name" [(ngModel)]="item.selected"></dx-select-box>
                          <button class="btn btn-outline-primary" (click)="addInvoice(item,item.quantity || 1)">
                            <i class="icon-shopping-basket"></i>
                            {{item.quantity*item.price | money: translator.getDefaultLang() }}
                          </button>
                        </div>

                      </div>
                    </div>

                  </div>
                </ng-container>
              </div>
            </ng-template>
          </ngb-tab>
        </ng-container>
      </ngb-tabset>
    </div>